const detectDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera || ""

  // Regular expressions for mobile devices
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i

  // Check if the user agent matches the mobile regex
  if (mobileRegex.test(userAgent)) {
    return "mobile"
  }

  // Check for tablet-specific cases
  if (/iPad|Android/.test(userAgent) && !/Mobile/.test(userAgent)) {
    return "tablet"
  }

  // If not mobile or tablet, assume it's desktop
  return "desktop"
}

// Additional helper functions
const isMobile = () => detectDevice() === "mobile"
const isTablet = () => detectDevice() === "tablet"
const isDesktop = () => detectDevice() === "desktop"

export { detectDevice, isMobile, isTablet, isDesktop }
